import i18n from '@/helper/i18n';

export default function formatCreditorStatus(value) {
  return i18n.te(`user.creditorStatusOptions.${value}`)
    ? i18n.t(`user.creditorStatusOptions.${value}`)
    : value;
}
